/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
  console.log(response);

  const offcanvasCart = document.querySelector("#offcanvas-cart");
  const cartPage = document.querySelector("#cart");

  offcanvasCart?.classList.add("loading");
  cartPage?.classList.add("loading");

  const newResponse = await fetch(window.location.href);
  const text = await newResponse.text();
  const newDocument = new DOMParser().parseFromString(text, "text/html");

  offcanvasCart
    ?.querySelector(".offcanvas-body")
    .replaceWith(newDocument.querySelector("#offcanvas-cart .offcanvas-body"));
  offcanvasCart
    ?.querySelector(".offcanvas-footer")
    .replaceWith(
      newDocument.querySelector("#offcanvas-cart .offcanvas-footer")
    );
  cartPage?.replaceWith(newDocument.querySelector("#cart"));

  document.querySelectorAll(".cart-count-badge").forEach((badge) => {
    badge.textContent =
      newDocument.querySelector(".cart-count-badge").textContent;
    badge.removeAttribute("hidden");
  });

  offcanvasCart?.classList.remove("loading");
  cartPage?.classList.remove("loading");

  window.dispatchEvent(new Event("updated.ecomify.cart"));

  if (response.ok) {
    if (response.url.includes("add.js")) {
      offcanvasCart
        ?.querySelector("#offcanvas-cart-alert-add")
        .removeAttribute("hidden");

      const data = await response.json();

      if (data.items?.length > 1) {
        const elemAlertItemsAdded = offcanvasCart?.querySelector(
          "#offcanvas-cart-alert-add [data-alert-items-added]"
        );

        elemAlertItemsAdded.textContent =
          elemAlertItemsAdded.textContent.replace("[count]", data.items.length);
        elemAlertItemsAdded.removeAttribute("hidden");
      } else {
        offcanvasCart
          ?.querySelector("#offcanvas-cart-alert-add [data-alert-item-added]")
          .removeAttribute("hidden");
      }
    } else {
      offcanvasCart
        ?.querySelector("#offcanvas-cart-alert-updated")
        .removeAttribute("hidden");
    }
  } else {
    const data = await response.json();
    const alert = document.querySelector("#offcanvas-cart-alert-error");
    alert.querySelector(
      "span"
    ).textContent = `${data.message} - ${data.description}`;
    alert.removeAttribute("hidden");
  }

  if (offcanvasCart?.querySelector("#offcanvas-cart-empty")) {
    setTimeout(() => {
      bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide();
    }, 1000);
  }

  if (offcanvasCart?.querySelector("#cart-shipping-rates")) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
      "shipping-rates-modal-country",
      "shipping-rates-modal-province",
      {
        hideElement: "shipping-rates-modal-province-wrapper",
      }
    );
  }
};

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  });
  window.refreshCartContents(response);
};

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: btn.dataset.lineItemKey,
      quantity: 0,
    }),
  });
  window.refreshCartContents(response);
};

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const note = btn.closest("#cart-note").querySelector('[name="note"]').value;

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  });

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`;

  setTimeout(() => {
    btn.innerHTML = btn.dataset.textBtnSave;
  }, 4000);
};

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
  btn.style.height = btn.clientHeight + "px";
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
};

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBar = document.querySelector("#cart-goal .progress-bar");
  if (progressBar) {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width;
    }, 250);
  }
};
initCartGoal();

window.addEventListener("updated.ecomify.cart", () => {
  initCartGoal();
});

// Cart Goal - Free product
const initCartGoalFreeProduct = async () => {
  const cartGoal = document.querySelector("#cart-goal");
  if (!cartGoal) return;

  const freeProductHandle = cartGoal.dataset.freeProductHandle;
  if (!freeProductHandle.length) return;

  const goalCompleted = cartGoal.dataset.goalCompleted === "2";
  let isFreeProductInCart = false;

  document.querySelectorAll("[data-cart-line-item]").forEach((elem) => {
    if (elem.dataset.productHandle === freeProductHandle) {
      isFreeProductInCart = true;
    }
  });

  const freeProductVariantId = Number(cartGoal.dataset.freeProductVariantId);

  if (goalCompleted) {
    if (!isFreeProductInCart) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: freeProductVariantId,
              quantity: 1,
            },
          ],
        }),
      });
      window.refreshCartContents(response);
    }
  }

  console.log(freeProductHandle);
};
initCartGoal();

window.addEventListener("updated.ecomify.cart", () => {
  initCartGoalFreeProduct();
});

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector("#cart-summary");

  if (!card) return;

  if (window.matchMedia("max-width: 991px").matches) return;

  const navbarHeight =
    document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
  const announcementBarHeight =
    document.querySelector('[id*="__announcement-bar"].sticky-top')
      ?.clientHeight || 0;

  card.style.position = "sticky";
  card.style.top = `${navbarHeight + announcementBarHeight + 20}px`;
};
initStickySummaryCard();

window.addEventListener("updated.ecomify.cart", () => {
  initStickySummaryCard();
});

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const wrapper = document.querySelector("#cart-shipping-rates-collapse");

  wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-danger")
    .setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-warning")
    .setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-success")
    .setAttribute("hidden", "hidden");

  const country = wrapper.querySelector("#shipping-rates-modal-country").value;
  const province = wrapper.querySelector(
    "#shipping-rates-modal-province"
  ).value;
  const zip = wrapper.querySelector("#shipping-rates-modal-zip").value;

  const prepareResponse = await fetch(
    `/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
    {
      method: "POST",
    }
  );
  console.log(prepareResponse);

  if (prepareResponse.ok) {
    const asyncRespose = await fetch(
      `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    console.log(asyncRespose);

    const data = await asyncRespose.json();
    console.log(data);

    let html = "";

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach((elem) => {
        html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `;
      });

      wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `;
      wrapper
        .querySelector("#shipping-rates-modal-alert-success")
        .removeAttribute("hidden");
    } else {
      wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `;
      wrapper
        .querySelector("#shipping-rates-modal-alert-warning")
        .removeAttribute("hidden");
    }
  } else {
    const data = await prepareResponse.json();
    console.log(data);

    let html = "";

    for (const [key, value] of Object.entries(data)) {
      html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `;
    }

    wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `;
    wrapper
      .querySelector("#shipping-rates-modal-alert-danger")
      .removeAttribute("hidden");
  }

  btn.innerHTML = btn.dataset.text;
};

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
  document
    .querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]')
    .forEach((elem) => {
      elem.addEventListener("click", () => {
        setTimeout(() => {
          const offcanvasBody = document.querySelector(
            "#offcanvas-cart .offcanvas-body"
          );
          offcanvasBody.scroll({
            top: offcanvasBody.scrollHeight,
            behavior: "smooth",
          });
        }, 250);
      });
    });
};
fixScrollingOffcanvasCollapses();

window.addEventListener("updated.ecomify.cart", () => {
  fixScrollingOffcanvasCollapses();
});

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.dataset.variantId),
          selling_plan: Number(select.value),
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

// Cart Min Order
const initCartMinOrder = () => {
  const wrapper = document.querySelector("#cart-min-order");
  if (!wrapper) return;

  if (wrapper.dataset.goalReached === "false") {
    wrapper.closest("form").querySelector(".btn-checkout").disabled = true;
  }
};
initCartMinOrder();
window.addEventListener("updated.ecomify.cart", () => {
  initCartMinOrder();
});

// Shipping protection
const initCartShippingProtection = async () => {
  if (!document.querySelector('[data-shipping-protection-enabled="true"]'))
    return;
  if (!document.querySelector('[data-shipping-protection-auto-init="true"]'))
    return;

  if (!window.localStorage.getItem("ecomify-shipping-protection-init")) {
    const variantId = Number(
      document.querySelector("[data-shipping-protection-variant-id]").dataset
        .shippingProtectionVariantId
    );

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    });

    window.refreshCartContents(response);
    window.localStorage.setItem("ecomify-shipping-protection-init", true);
  }
};
window.addEventListener("updated.ecomify.cart", () => {
  initCartShippingProtection();
});

window.onChangeCartShippingProtection = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.value),
          selling_plan: select.dataset.sellingPlanId.length
            ? Number(select.dataset.sellingPlanId)
            : null,
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// CUSTOM ~ Terms checkbox
const initTermsCheckbox = () => {
  const checkbox = document.querySelector("#cart-terms-checkbox");
  const termsModal = document.querySelector("#terms-modal");
  const acceptBtn = document.querySelector("#accept-terms-btn");
  const modalBody = document.querySelector("#terms-modal .modal-body");

  if (!checkbox || !termsModal) {
    sandy.log("Required elements not found");
    return;
  }

  const checkoutBtn = checkbox.closest("form").querySelector(".btn-checkout");
  if (!checkoutBtn) {
    sandy.log("Checkout button not found");
    return;
  }

  checkoutBtn.disabled = true;
  sandy.log("Checkout button disabled", checkoutBtn.disabled);

  // Check if screen width is mobile size
  let isMobile = window.innerWidth < 768;

  // Update isMobile on window resize
  window.addEventListener("resize", () => {
    isMobile = window.innerWidth < 768;
  });

  // Create tooltip element
  const tooltip = document.createElement("div");
  tooltip.style.cssText = `
    position: absolute;
    background-color:rgb(253, 227, 229);
    border: 1px solid #dc3545;
    color: #dc3545;
    padding: 8px 12px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    pointer-events: none;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  `;
  tooltip.textContent = "Please read all terms and conditions before accepting";
  termsModal.appendChild(tooltip);

  // Wrap the accept button in a container
  const btnContainer = document.createElement("div");
  btnContainer.style.cssText = `
    position: relative;
    display: inline-block;
  `;
  acceptBtn.parentNode.insertBefore(btnContainer, acceptBtn);
  btnContainer.appendChild(acceptBtn);

  let tooltipTimeout;

  const showTooltip = () => {
    if (acceptBtn.disabled) {
      const btnRect = acceptBtn.getBoundingClientRect();
      const modalRect = termsModal.getBoundingClientRect();
      tooltip.style.top = `${
        btnRect.top - modalRect.top - tooltip.offsetHeight - 10
      }px`;
      tooltip.style.left = `${btnRect.left - modalRect.left - 90}px`;
      tooltip.style.visibility = "visible";
      tooltip.style.opacity = "1";

      // On mobile, set timeout to hide tooltip
      if (isMobile) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = setTimeout(() => {
          hideTooltip();
        }, 3000);
      }
    }
  };

  const hideTooltip = () => {
    tooltip.style.opacity = "0";
    // Wait for fade out animation to complete before hiding
    setTimeout(() => {
      tooltip.style.visibility = "hidden";
    }, 300);
  };

  // Handle container hover
  btnContainer.addEventListener("mouseenter", () => {
    sandy.log("Button container hovered", acceptBtn.disabled);
    showTooltip();
  });

  btnContainer.addEventListener("mouseleave", () => {
    sandy.log("Button container left", acceptBtn.disabled);
    if (!isMobile) {
      hideTooltip();
    }
  });

  // Handle touch events for mobile
  if (isMobile) {
    btnContainer.addEventListener("touchstart", () => {
      showTooltip();
    });
  }

  // Handle accept button click
  acceptBtn.addEventListener("click", () => {
    if (!acceptBtn.disabled) {
      checkbox.checked = true;
      sessionStorage.setItem("termsAccepted", "true");
      checkoutBtn.disabled = false;
      const termsBsModal = bootstrap.Modal.getInstance(termsModal);
      if (termsBsModal) {
        termsBsModal.hide();
      }
    }
  });

  // Debug logging
  // sandy.log("Terms modal elements:", {
  //   checkbox: checkbox,
  //   termsModal: termsModal,
  //   acceptBtn: acceptBtn,
  //   modalBody: modalBody,
  //   checkboxChecked: checkbox.checked,
  // });

  // Check session storage on page load
  const termsAccepted = sessionStorage.getItem("termsAccepted");
  if (termsAccepted === "true") {
    checkbox.checked = true;
    checkoutBtn.disabled = false;
  }

  // Handle checkbox click
  checkbox.addEventListener("click", (e) => {
    //   e.preventDefault();
    checkbox.checked = !checkbox.checked;
    //   sandy.log("Checkbox clicked, current state:", checkbox.checked);

    if (checkbox.checked) {
      // sandy.log("Checkbox is checked");
      // If trying to uncheck, allow it
      checkoutBtn.disabled = true;
      sessionStorage.removeItem("termsAccepted");
      checkbox.checked = false;
    } else {
      // sandy.log("Checkbox is unchecked");
      // If trying to check the box, prevent default and show modal
      const termsBsModal = new bootstrap.Modal(termsModal);
      termsBsModal.show();
    }
  });

  // Handle modal events
  termsModal.addEventListener("show.bs.modal", function () {
    // sandy.log("Modal is about to show");
    acceptBtn.disabled = true;
  });

  termsModal.addEventListener("shown.bs.modal", function () {
    // sandy.log("Modal is shown");
  });

  // Handle modal scroll
  modalBody.addEventListener("scroll", () => {
    const isAtBottom =
      modalBody.scrollHeight - modalBody.scrollTop <=
      modalBody.clientHeight + 100;
    acceptBtn.disabled = !isAtBottom;

    // Fade out review button when not near top
    const reviewBtn = document.querySelector("#review-terms-btn");
    if (modalBody.scrollTop > 100) {
      reviewBtn.style.opacity = "0";
    } else {
      reviewBtn.style.opacity = "1";
    }
  });

  // Handle review button click
  const reviewBtn = document.querySelector("#review-terms-btn");
  reviewBtn.addEventListener("click", () => {
    modalBody.scrollTo({
      top: modalBody.scrollHeight,
      behavior: "smooth",
    });
  });

  // Handle close button click
  termsModal.querySelector(".btn-close").addEventListener("click", () => {
    checkbox.checked = false;
    sessionStorage.setItem("termsAccepted", "false");
    const termsBsModal = bootstrap.Modal.getInstance(termsModal);
    termsBsModal.hide();
  });

  // Handle close button in footer
  termsModal.querySelector(".btn-secondary").addEventListener("click", () => {
    // sandy.log("Close button in footer clicked", checkbox);
    checkbox.checked = false;
    sessionStorage.setItem("termsAccepted", "false");
    const termsBsModal = bootstrap.Modal.getInstance(termsModal);
    termsBsModal.hide();
  });
};
initTermsCheckbox();

window.addEventListener("updated.ecomify.cart", () => {
  initTermsCheckbox();
  sandy.log("Cart updated");
});

// Cart Discount
window.onCartDiscountClick = async (btn) => {
  const wrapper = document.querySelector("#cart-discount");

  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
  await fetch(`/discount/${wrapper.querySelector(".form-control").value}`);
  window.location.href = "/checkout";
};
